export const TRANSACTION_MODAL_TITLE = 'Transaction'
export const TRANSACTION_MODAL_TITLE_NEW = 'New transaction'

export const TRANSFERS = [
  'transfer in',
  'transfer out',
  'interest expense',
]
